import { Fragment, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import BookingEnquirePopup from '../popups/BookingEnquirePopup'

export default function IndividualBooking() {
  const [isOpen, triggerPopup] = useState(false)

  return (
    <Fragment>
      <a onClick={() => triggerPopup(true)} >
        <FormattedMessage id='email.us' defaultMessage='Email us' />
      </a>
      <BookingEnquirePopup closeModal={() => triggerPopup(false)} isOpen={isOpen} />
    </Fragment>
  )
}
